
export class UserSession {

  userId?: number;
  userType?: string;
  email?: string;
  firstName?: string;
  lastName?: string;
  completeName?: string;
  roles?: Array<string>;
  avatarUrl?: string;
  clientLogo?: string;
  isPasswordPrivate?: boolean;
  agreement?: boolean;
  dateConfigObject?: any;
  timeConfigObject?: any;
  languageId?: number;
  languageCode?: string;
  clientId?: string;
  phoneNumber?: string;
}
